import { Pipe, PipeTransform } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { IsGallery } from '../../lib/is-gallery';

export const sortGalleriesAndFolders = <T>(
  items: T[],
  foldersFirst = false,
  sorting: string,
  pinFavourites: boolean,
  key?: string
) => {
  let sortBy = sorting || '-created_at';
  let val = 1;
  if (sortBy[0] === '-') {
    sortBy = sortBy.substring(1);
    val = -1;
  }

  let sortedItems = items.slice().sort((a, b) => {
    if (key) {
      a = a[key];
      b = b[key];
    }

    if (typeof a[sortBy] === 'string') {
      return ((a[sortBy] || 'Untitled') as string).localeCompare(b[sortBy] || 'Untitled') * val;
    }
    return (a[sortBy] || 'Untitled') > (b[sortBy] || 'Untitled') ? val : -val;
  });

  if (pinFavourites) {
    sortedItems = [
      ...sortedItems.filter(item => item['is_favourite']),
      ...sortedItems.filter(item => !item['is_favourite']),
    ];
  }

  if (foldersFirst) {
    sortedItems = [
      ...sortedItems.filter(item => !IsGallery(item as GalleryDto)),
      ...sortedItems.filter(item => IsGallery(item as GalleryDto)),
    ];
  }

  return sortedItems;
};

@Pipe({
  name: 'galleriesSortBy',
  pure: false,
  standalone: true,
})
export class GalleriesSortByPipe implements PipeTransform {
  transform<T>(items: T[], foldersFirst = false, sorting: string, pinFavourites: boolean, key?: string): T[] {
    return sortGalleriesAndFolders(items, foldersFirst, sorting, pinFavourites, key);
  }
}
